import { motion } from "framer-motion";
import { CalendarDays, Hourglass, Sprout } from "lucide-react";
import { FUTURE } from "@/data";

const genreClass = {
    Fantasy: "badge-fantasy",
    Fantascienza: "badge-fantascienza",
    Romantasy: "badge-fantasy",
    Comics: "badge-fantascienza",
    "Evento speciale": "badge-done",
};

export default function FutureLetture() {
    return (
        <div>
            <div className="grid md:grid-cols-2 gap-5" data-testid="future-grid">
                {FUTURE.map((b, i) => {
                    const isNext = b.badge === "next";
                    return (
                        <motion.article
                            key={b.id}
                            className={`parchment-card p-5 sm:p-6 flex flex-col gap-4 ${isNext ? "brass-frame" : b.badge === "coming" ? "" : "border-dashed opacity-80"}`}
                            initial={{ opacity: 0, y: 22 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.15 }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            data-testid={`future-card-${b.id}`}
                        >
                            <div className="flex items-start gap-4">
                                <div className="shrink-0 w-12 h-12 rounded-full border border-[#b08d57]/60 bg-[rgba(176,141,87,0.14)] flex items-center justify-center text-[#7a5a2e]">
                                    <b.icon size={22} strokeWidth={1.5} />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h3 className="f-title text-lg leading-snug text-[#3f2a12]">{b.title}</h3>
                                    <p className="f-body italic text-[#6d5638] mt-1 text-sm sm:text-base">{b.by}</p>
                                </div>
                            </div>
                            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                                {isNext ? (
                                    <span className="badge badge-next">
                                        <Hourglass size={12} /> Prossimo
                                    </span>
                                ) : b.badge === "coming" ? (
                                    <span className="badge badge-done">
                                        <Hourglass size={12} /> In programma
                                    </span>
                                ) : (
                                    <span className="badge badge-proposal">
                                        <Sprout size={12} /> Proposta
                                    </span>
                                )}
                                <span className={`badge ${genreClass[b.genre]}`}>{b.genre}</span>
                                {b.date && (
                                    <span className="f-detail text-sm text-[#7a5a2e] flex items-center gap-1.5">
                                        <CalendarDays size={13} /> {b.date}
                                    </span>
                                )}
                            </div>
                        </motion.article>
                    );
                })}
            </div>
            <p className="f-body italic text-[#6d5638] text-center mt-10 text-base" data-testid="future-note">
                La sezione è in crescita: ad ogni incontro il tomo si scrive una pagina nuova.
            </p>
        </div>
    );
}
